import { render, staticRenderFns } from "./goDehe.vue?vue&type=template&id=5fa76718&scoped=true&"
import script from "./goDehe.vue?vue&type=script&lang=js&"
export * from "./goDehe.vue?vue&type=script&lang=js&"
import style0 from "./goDehe.vue?vue&type=style&index=0&id=5fa76718&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa76718",
  null
  
)

export default component.exports